import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ROXY_STATES, roxyStateWord } from './roxyStates';
import './RoxyOrb.scss';

const AUTHORED = 120;

const RING_ARC = 'M80.66 98.85A44 44 0 1 1 101.85 73.60';
const RING_HANDLE = 'M92.17 87L103.66 96.64';

let orbSeq = 0;

const RoxyOrb = ({ state, size, className }) => {

    const uid = useRef(null);
    if (uid.current === null) {
        orbSeq += 1;
        uid.current = `roxy${orbSeq}`;
    }
    const bodyId = `${uid.current}-body`;
    const sweepId = `${uid.current}-sweep`;

    return (
        <span
            className={`roxy-orb roxy-orb--${state}${className ? ` ${className}` : ''}`}
            style={{ '--roxy-orb-size': `${size}px` }}
            role="img"
            aria-label={`Roxy — ${roxyStateWord(state)}`}
        >
            <span className="roxy-orb__glow" aria-hidden="true" />
            <span className="roxy-orb__ripples" aria-hidden="true">
                <i /><i /><i />
            </span>
            <svg
                className="roxy-orb__svg"
                viewBox={`0 0 ${AUTHORED} ${AUTHORED}`}
                aria-hidden="true"
                focusable="false"
            >
                <defs>
                    <radialGradient id={bodyId} cx="35%" cy="27%" r="74%">
                        <stop offset="0%" stopColor="#FFFFFF" />
                        <stop offset="22%" stopColor="#E7E2FF" />
                        <stop offset="55%" stopColor="#B4A9FA" />
                        <stop offset="82%" stopColor="#9186EE" />
                        <stop offset="100%" stopColor="#7A6DDE" />
                    </radialGradient>
                    <linearGradient id={sweepId} x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#A79BF5" stopOpacity="0" />
                        <stop offset="100%" stopColor="#7A6DDE" stopOpacity="1" />
                    </linearGradient>
                </defs>

                <g className="roxy-orb__ring">
                    <path className="roxy-orb__ring-arc" d={RING_ARC} />
                    <path className="roxy-orb__ring-handle" d={RING_HANDLE} />
                </g>
                <g className="roxy-orb__sweep">
                    <path d={RING_ARC} stroke={`url(#${sweepId})`} />
                </g>

                <circle className="roxy-orb__body" cx="60" cy="60" r="30" fill={`url(#${bodyId})`} />

                <g className="roxy-orb__face">
                    <rect className="roxy-orb__eye roxy-orb__eye--left" x="52.5" y="50.5" width="4.6" height="9.5" rx="2.3" />
                    <rect className="roxy-orb__eye roxy-orb__eye--right" x="63" y="50.5" width="4.6" height="9.5" rx="2.3" />

                    <path className="roxy-orb__mouth roxy-orb__mouth--smile" d="M55 68.6Q59.5 72.6 66 66.6" />
                    <path className="roxy-orb__mouth roxy-orb__mouth--grin" d="M53.5 67Q60 74.5 66.5 67" />
                    <path className="roxy-orb__mouth roxy-orb__mouth--flat" d="M55.5 69.5H64.5" />
                    <ellipse className="roxy-orb__mouth--open" cx="60" cy="69" rx="4.2" ry="3.2" />
                    <g className="roxy-orb__mouth--dots">
                        <circle cx="54.6" cy="69" r="1.7" />
                        <circle cx="60" cy="69" r="1.7" />
                        <circle cx="65.4" cy="69" r="1.7" />
                    </g>
                </g>
            </svg>
        </span>
    );
};

RoxyOrb.propTypes = {
    state: PropTypes.oneOf(Object.values(ROXY_STATES)),
    size: PropTypes.number,
    className: PropTypes.string,
};

RoxyOrb.defaultProps = {
    state: ROXY_STATES.IDLE,
    size: AUTHORED,
    className: '',
};

export default RoxyOrb;
